import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ProtectedOrganizationRoute } from "@/components/ProtectedOrganizationRoute";

// Organization/Association pages (only existing pages)
const AssociationDashboard = lazy(() => import("@/pages/association/AssociationDashboard"));

/**
 * Organization/Association routes
 * Routes for association_staff role
 *
 * Note: Only AssociationDashboard exists currently.
 * Add more routes as new pages are created.
 */
export const organizationRoutes = (
  <>
    <Route
      path="/association/:orgId"
      element={
        <ProtectedRoute requiredRoles={["association_staff"]}>
          <ProtectedOrganizationRoute>
            <AssociationDashboard />
          </ProtectedOrganizationRoute>
        </ProtectedRoute>
      }
    />
  </>
);
